export const tr = {
    'error-add': 'Hata! Ürün eklenemedi',
    'success-add': 'Ürün eklendi'
};
